<template>
    <div class="contacts-board-view-container">
        <div v-for="(contact, indx) in renderContacts" :key="indx" class="contacts-card">
            <div class="user-avatar">
                <img :src="contactAvatar(contact)" alt="contact-avatar" />
            </div>
            <div class="contact-card-content">
                <p class="contact-name">{{ contact.name }}</p>
                <p class="contact-profile-name">{{ contactProfileName(contact) }}</p>
                <div class="contact-keyword-wrapper">
                    <div
                        v-for="(keyword, indx) in contactKeywords(contact)"
                        :key="indx"
                        class="contact-keyword"
                    >
                        <p @click="handleFilterKeyword(keyword)" class="keyword">
                            {{ keyword }}
                        </p>
                    </div>
                </div>
                <div class="contact-actions">
                    <button
                        v-if="showBookBtn(contact)"
                        @click="handleBookContact(user, contact)"
                        class="book-btn"
                    >
                        Book
                    </button>
                    <div class="icon-btns">
                        <!-- @TODO: once features are available uncomment -->
                        <!-- <button class="msg-btn"> -->
                        <!--     <img :src="URLS.icons.msgBubble" alt="msg-btn" /> -->
                        <!-- </button> -->
                        <button
                            @click="toggleSubMenu(renderContacts, contact)"
                            class="kebab-menu"
                        >
                            <img :src="URLS.icons.vertKebab" alt="kebab-menu" />
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="contact.showMenu" class="sub-menu">
                <div
                    v-for="(item, indx) in subMenuItems(contact)"
                    :key="indx"
                    class="sub-menu-item"
                >
                    <p
                        v-if="item.text"
                        @click="handleSubMenuInvoke(contact, item)"
                        class="item"
                    >
                        {{ item.text }}
                    </p>
                    <div v-else class="divider"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import useProfileContacts from '@/composables/useProfileContacts.js'

    export default {
        name: 'ContactsBoardView',
        props: {
            user: {
                required: true,
                type: Object
            },
            contacts: {
                required: true,
                type: Array
            }
        },
        emits: ['filter-keyword', 'remove-contact'],
        computed: {
            contactAvatar: (self) => (contact) =>
                (contact.avatar && contact.avatar.includes('/images/global/default.png')) ||
                !contact.avatar
                    ? self.URLS.icons.defaultContact
                    : contact.avatar,
            contactProfileName: () => (contact) => {
                return contact.artist_id
                    ? `Artist: ${contact.band_name ?? 'User'}`
                    : `Venue: ${contact.venue_name ?? 'User'}`
            }
        },
        setup(props, context) {
            const {
                URLS,
                renderContacts,
                showBookBtn,
                contactKeywords,
                subMenuItems,
                initContactsForView,
                toggleSubMenu,
                handleFilterKeyword,
                handleSubMenuInvoke,
                handleBookContact,
                handleRemoveContact,
                handleViewProfile
            } = useProfileContacts(props, context)

            return {
                URLS,
                renderContacts,
                showBookBtn,
                contactKeywords,
                subMenuItems,
                initContactsForView,
                toggleSubMenu,
                handleFilterKeyword,
                handleSubMenuInvoke,
                handleBookContact,
                handleRemoveContact,
                handleViewProfile
            }
        }
    }
</script>
<style lang="scss" scoped>
    .contacts-board-view-container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        max-width: 692px;
        gap: 20px;

        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        .contacts-card {
            width: 336px;
            height: 336px;
            border-radius: 15px;
            background: #262626;
            box-shadow: 0px 0px 0px 1px #262626;
            position: relative;

            .user-avatar {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 1;

                img {
                    width: 336px;
                    height: 336px;
                    border-radius: 15px;
                    object-fit: cover;
                }
            }
            .user-avatar:after {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(
                    to bottom,
                    transparent 35%,
                    rgba(0, 0, 0, 0.9) 100%
                );
                border-radius: 15px;
            }
            .contact-card-content {
                position: relative;
                z-index: 2;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 16px;
                padding: 172px 16px 16px 16px;
                height: 100%;

                .contact-name {
                    color: #f5f5f5;
                    font-family: Instrument Sans;
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 550;
                    line-height: 120%;
                    letter-spacing: -0.2px;
                }
                .contact-profile-name {
                    color: #dedede;
                    font-family: Instrument Sans;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 130%;
                    letter-spacing: 0.14px;
                }
                .contact-keyword-wrapper {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    gap: 2px;

                    .contact-keyword {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        gap: 2px;
                        border-radius: 100px;
                        border: 1px solid #8b8b8b;
                        padding: 2px 8px;
                        max-width: 50px;

                        .keyword {
                            color: #acacac;
                            font-family: Instrument Sans;
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 650;
                            line-height: 135%;
                            letter-spacing: 0.12px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            cursor: pointer;
                        }
                    }
                }
                .contact-actions {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    gap: 8px;
                    width: 100%;
                    margin-top: auto;

                    .book-btn {
                        padding: 7px 30px 9px 30px;
                        min-width: 216px;
                        background: transparent;
                        border-radius: 100px;
                        border: 1px solid #8b8b8b;
                        color: #cdeb09;
                        font-family: Instrument Sans;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 125%;
                    }

                    .icon-btns {
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        gap: 8px;
                        margin-left: auto;
                        position: relative;

                        .msg-btn,
                        .kebab-menu {
                            padding: 6px;
                            border-radius: 8px;
                            background: #262626;
                        }
                    }
                }
            }
            .sub-menu {
                position: absolute;
                width: 140px;
                padding: 12px;
                border-radius: 8px;
                display: flex;
                flex-direction: column;
                gap: 8px;
                background: #464646;
                box-shadow: 0px 6px 12px -6px rgba(0, 0, 0, 0.5);
                right: 57px;
                bottom: -73px;
                z-index: 3;

                .item {
                    overflow: hidden;
                    color: #dedede;
                    text-overflow: ellipsis;
                    font-family: Instrument Sans;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 130%;
                    letter-spacing: 0.14px;
                    cursor: pointer;
                }

                .divider {
                    width: 100%;
                    height: 1px;
                    background: #646464;
                }
            }
        }
    }
</style>
